"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureV4RestClient = void 0;
var aws_amplify_1 = require("aws-amplify");
var SignatureV4RestClient = /** @class */ (function () {
    function SignatureV4RestClient(apiName) {
        if (apiName === void 0) { apiName = 'xemelgoCustomerConfig'; }
        this.apiName = apiName;
    }
    SignatureV4RestClient.prototype.post = function (path, payload) {
        var promise = aws_amplify_1.API.post(this.apiName, path, {
            body: payload
        });
        return promise;
    };
    SignatureV4RestClient.prototype.patch = function (path, payload) {
        var promise = aws_amplify_1.API.patch(this.apiName, path, {
            body: payload
        });
        return promise;
    };
    SignatureV4RestClient.prototype.put = function (path, payload) {
        var promise = aws_amplify_1.API.put(this.apiName, path, {
            body: payload
        });
        return promise;
    };
    SignatureV4RestClient.prototype.get = function (path) {
        var promise = aws_amplify_1.API.get(this.apiName, path, null);
        return promise;
    };
    SignatureV4RestClient.prototype.delete = function (path) {
        var promise = aws_amplify_1.API.del(this.apiName, path, null);
        return promise;
    };
    return SignatureV4RestClient;
}());
exports.SignatureV4RestClient = SignatureV4RestClient;
//# sourceMappingURL=signature-v4-rest-client.js.map